module.exports = __webpack_public_path__ + "ab673bac3a9e36cb1d4e54777c413fe3.ttf";